// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"b9f39f9c","377":"3b58b305","750":"d3ea4d3e","891":"237805cb"}[chunkId] + ".chunk.js";
};